import './boxes.css';


(function($){

    let currencies_boxes = $('#currencies-boxes'), currenciesBoxesLoaded = false;
    let commodities_boxes = $('#commodities-boxes'), commoditiesBoxesLoaded = false;
    let shares_boxes = $('#shares-boxes'), sharesBoxesLoaded = false;
    let indices_boxes = $('#indices-boxes'), indicesBoxesLoaded = false;
    let etfs_boxes = $('#etfs-boxes'), etfsBoxesLoaded = false;
    let crypto_boxes = $('#crypto-boxes'), cryptoBoxesLoaded = false;

    let max_lines = "";

    let sliderCinfig = '';

    if($('#page').hasClass('instruments')){
        max_lines = 12;
    }else if($('#page').hasClass('instruments-hub')){
        max_lines = 8;
    }
      sliderCinfig  = {
            item: 2,
            loop: false,
            slideMove: 2,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            speed: 600,
            onSliderLoad: function () {},
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        item: 4,
                        slideMove: 2,
                        slideMargin: 6,
                    }
                },
                {
                    breakpoint: 620,
                    settings: {
                        item: 3,
                        slideMove: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        item: 2,
                        slideMove: 2
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        item: 1,
                        slideMove: 1
                    }
                }
            ]
        };

        let env = window.getparam('env') || 'prod';

            const script = document.createElement('script');
            document.body.appendChild(script);
            script.async = true;
            script.defer = true;
            script.src = 'https://content.webapi-services.net/web_assets/scripts/live-rates/boxes.var.min.js?env='+env;
            script.onload = () => {
                loadBoxes();
            }; 
        
        
        function loadBoxes(){

            if (currencies_boxes.length > 0 && !currenciesBoxesLoaded ) {
                currenciesBoxesLoaded = true;
                LiveRates.default(
                    {
                        folder: 76,
                        broker: 1,
                        frequency: 6000,
                        container: 'currencies-boxes',
                        maxLines : max_lines,
                        exclude : [],
                        cssLink : '',
                        headers:'',
                        lang : 'ja',
                        icons : true,
                        preset: 3,
                        sliderConfig : sliderCinfig,
                        lightSliderMob: true
                    }
                ).then(() => {
                
                }).catch(err  => {
                    console.error(err);
                });
            }

            if (commodities_boxes.length > 0 && !commoditiesBoxesLoaded ) {
                commoditiesBoxesLoaded = true;

                LiveRates.default(
                    {
                        folder: 76,
                        broker: 1,
                        frequency: 6000,
                        container: 'commodities-boxes',
                        maxLines : max_lines,
                        exclude : [],
                        cssLink : '',
                        headers:'',
                        lang : 'ja',
                        icons : true,
                        preset: 9,
                        sliderConfig : sliderCinfig, //pass json {} with slider config,
                        lightSliderMob : true
                        
                    }
                ).then(() => {

                }).catch(err  => {
                    console.error(err);
                });
            }

            if (shares_boxes.length > 0 && !sharesBoxesLoaded ) {
                sharesBoxesLoaded = true;

                LiveRates.default(
                    {
                        folder: 76,
                        broker: 1,
                        frequency: 6000,
                        container: 'shares-boxes',
                        maxLines : max_lines,
                        exclude : [],
                        cssLink : '',
                        headers:'',
                        lang : 'ja',
                        icons : true,
                        preset: 12,
                        sliderConfig : sliderCinfig,
                        lightSliderMob: true
                    }
                ).then(() => {

                }).catch(err  => {
                    console.error(err);
                });
            }

            if (indices_boxes.length > 0 && !indicesBoxesLoaded ) {
                indicesBoxesLoaded = true;

                LiveRates.default(
                    {
                        folder: 76,
                        broker: 1,
                        frequency: 6000,
                        container: 'indices-boxes',
                        maxLines : max_lines,
                        exclude : [],
                        cssLink : '',
                        headers:'',
                        lang : 'ja',
                        icons : true,
                        preset: 113,
                        sliderConfig : sliderCinfig,
                        lightSliderMob: true
                    }
                ).then(() => {

                }).catch(err  => {
                    console.error(err);
                });
            }

            if (etfs_boxes.length > 0 && !etfsBoxesLoaded ) {
                etfsBoxesLoaded = true;

                LiveRates.default(
                    {
                        folder: 76,
                        broker: 1,
                        frequency: 6000,
                        container: 'etfs-boxes',
                        maxLines : max_lines,
                        exclude : [],
                        cssLink : '',
                        headers:'',
                        lang : 'ja',
                        icons : true,
                        preset: 104,
                        sliderConfig : sliderCinfig,
                        lightSliderMob: true
                    }
                ).then(() => {

                }).catch(err  => {
                    console.error(err);
                });
            }

            if (crypto_boxes.length > 0 && !cryptoBoxesLoaded ) {
                cryptoBoxesLoaded = true;

                LiveRates.default(
                    {
                        folder: 76,
                        broker: 1,
                        frequency: 6000,
                        container: 'crypto-boxes',
                        maxLines : max_lines,
                        exclude : [],
                        cssLink : '',
                        headers:'',
                        lang : 'ja',
                        icons : true,
                        preset: 124,
                        sliderConfig : sliderCinfig,
                        lightSliderMob: true
                    }
                ).then(() => {

                }).catch(err  => {
                    console.error(err);
                });
            }

             
        }

       
        
})(window.jQuery);